import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNotInThePastErrorMessage = (
  <Trans>
    Ce champ doit posséder une date dans le passé
  </Trans>
);
